<template>
  <div class="base-container">
    <div class="header-line">
      <span>{{ title }}</span>
      <div>
        <slot name="header-right"></slot>
      </div>
    </div>
    <div class="main-container">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.header-line {
  background: #eee;
  margin: 20px 0;
  padding: 5px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.main-container {
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// BaseContainer.vue?62a44928